import Button from '@mui/material/Button';
import styled from '@mui/material/styles/styled';

export const M3ButtonBase = styled(Button)`
  border: 0;
  height: 40px;
  border-radius: 32px;
  padding-left: 12px;
  padding-right: 12px;
  transition: none;
  font-size: 14px;
  font-weight: 500;
  text-transform: initial;
  color: var(--md-sys-color-on-surface-light);
  white-space: nowrap;

  .MuiSvgIcon-root {
    font-size: 22px;
    margin-right: 8px;
  }

  .m3-button-outlined-background {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    position: absolute;
    border-radius: 40px;
    pointer-events: none;
  }

  &.active,
  &:hover {
    background-color: var(--md-sys-color-surface-variant-light);
  }

  &.MuiButton-containedPrimary {
    color: var(--md-ref-palette-primary100);
    background-color: var(--md-ref-palette-primary40);
  }

  &.MuiButton-containedSecondary {
    color: var(--md-ref-palette-secondary100);
    background-color: var(--md-ref-palette-secondary40);
  }

  &.MuiButton-contained {
    &:hover {
      box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    }
  }

  &.MuiButton-outlinedPrimary,
  &.MuiButton-outlinedSecondary {
    border: 0;
    box-shadow: 0 0 0 1px var(--md-ref-palette-neutral-variant80);

    &:hover {
      border: 0;
      background: transparent !important;

      .m3-button-outlined-background {
        opacity: 0.08;
      }
    }
  }

  &.dark-mode-button {
    color: var(--md-sys-color-on-background-dark);

    .MuiSvgIcon-root {
      color: var(--md-sys-color-on-background-dark);
    }

    &.active,
    &:hover {
      background-color: var(--md-sys-color-surface-variant-dark);
    }

    &.MuiButton-containedPrimary,
    &.MuiButton-containedSecondary {
      .MuiSvgIcon-root {
        color: var(--md-sys-color-background-dark);
      }
    }

    &.MuiButton-containedPrimary {
      color: var(--md-ref-palette-primary0);
      background-color: var(--md-ref-palette-primary80);
    }

    &.MuiButton-containedSecondary {
      color: var(--md-ref-palette-secondary0);
      background-color: var(--md-ref-palette-secondary20);
    }

    &.MuiButton-contained {
      &:hover {
        box-shadow: 0px 2px 1px -1px rgba(255, 255, 255, 0.2),
          0px 1px 1px 0px rgba(255, 255, 255, 0.14),
          0px 1px 3px 0px rgba(255, 255, 255, 0.12);
      }
    }

    &.MuiButton-outlinedPrimary,
    &.MuiButton-outlinedSecondary {
      box-shadow: 0 0 0 1px var(--md-ref-palette-neutral-variant30);
    }
  }
`;
